// extracted by mini-css-extract-plugin
export var chip = "_aj-0";
export var filterDropdown = "_aj-5";
export var filterItem = "_aj-6";
export var icon = "_aj-1";
export var removeButton = "_aj-3";
export var removeIcon = "_aj-4";
export var separator = "_aj-2";